import React, { useEffect, useCallback } from 'react'
import { func, string } from 'prop-types'
import { Link } from 'gatsby'

import ExpandedMenu from './ExpandedMenu'
import { HamburgerIcon, CloseIcon, SearchIcon, NpfLogo } from '../Icons'
import * as Styled from './styles/PrimaryNavigation.styles'
import { NAV_MENU_STATUS } from '../../util/constants'

const isNavOpen = navMenuStatus => navMenuStatus !== NAV_MENU_STATUS.CLOSED

const HamburgerButton = ({
  navMenuStatus,
  isNavMenuOpen,
  setNavMenuStatus,
}) => (
  <Styled.HamburgerButton
    onClick={() =>
      setNavMenuStatus(
        isNavMenuOpen ? NAV_MENU_STATUS.CLOSED : NAV_MENU_STATUS.OPEN_NAV
      )
    }
  >
    {navMenuStatus === NAV_MENU_STATUS.OPEN_NAV ? (
      <CloseIcon />
    ) : (
      <HamburgerIcon />
    )}
    {navMenuStatus === NAV_MENU_STATUS.OPEN_NAV ? 'Close' : 'Menu'}
  </Styled.HamburgerButton>
)

const SearchButton = ({ isNavMenuOpen, setNavMenuStatus }) => (
  <Styled.SearchButton
    onClick={() =>
      setNavMenuStatus(
        isNavMenuOpen ? NAV_MENU_STATUS.CLOSED : NAV_MENU_STATUS.OPEN_SEARCH
      )
    }
  >
    <SearchIcon />
    Search
  </Styled.SearchButton>
)

const NavBar = ({ navMenuStatus, isNavMenuOpen, setNavMenuStatus }) => (
  <Styled.NavBar>
    <HamburgerButton
      navMenuStatus={navMenuStatus}
      isNavMenuOpen={isNavMenuOpen}
      setNavMenuStatus={setNavMenuStatus}
    />
    <Link to="/">
      <NpfLogo forMobileNav />
    </Link>
    <SearchButton
      isNavMenuOpen={isNavMenuOpen}
      setNavMenuStatus={setNavMenuStatus}
    />
  </Styled.NavBar>
)

const PrimaryNavigation = ({ navMenuStatus, setNavMenuStatus }) => {
  const escapeButtonTrap = useCallback(event => {
    if (event.keyCode === 27 && navMenuStatus !== NAV_MENU_STATUS.CLOSED) {
      setNavMenuStatus(NAV_MENU_STATUS.CLOSED)
    }
  })
  useEffect(() => {
    document.addEventListener('keydown', escapeButtonTrap, false)
    return () => {
      document.removeEventListener('keydown', escapeButtonTrap, false)
    }
  })
  return (
    <>
      <NavBar
        navMenuStatus={navMenuStatus}
        isNavMenuOpen={isNavOpen(navMenuStatus)}
        setNavMenuStatus={setNavMenuStatus}
      />
      <ExpandedMenu
        navMenuStatus={navMenuStatus}
        isNavMenuOpen={isNavOpen(navMenuStatus)}
        setNavMenuStatus={setNavMenuStatus}
      />
    </>
  )
}

PrimaryNavigation.propTypes = {
  setNavMenuStatus: func,
  navMenuStatus: string,
}

export default PrimaryNavigation
